export async function fileToDataURL(file: File) {
  return new Promise<string>((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = async (e) => {
      const dataURL = e.target!.result;
      resolve(dataURL as string);
    };
    fileReader.readAsDataURL(file);
  });
}
